// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ad329a24","171":"50b86b6d","488":"6ccb9432","994":"02de5583"}[chunkId] + ".chunk.js";
};